module.exports = __webpack_public_path__ + "static/media/ism.4d4dba47.png";